import React, { useEffect, useRef, useState } from "react";
import {
  ClientImage,
  ClientName,
  Description,
  Feedback,
  MainImage,
  ImageContainer,
  ImageWrapper,
  ImagesWrapper,
  Title,
  TitleFeedbacksWrapper,
  Wrapper,
  TopTriangle,
  BottomTriangle,
  ProgressRingWrapper,
  ProgressRing,
} from "./styles";
import karenImg from "../../../../assets/pages/NewHome/FeedbackSection/karen.png";
import topTriangleSvg from "../../../../assets/pages/NewHome/FeedbackSection/top-triangle.svg";
import bottomTriangleSvg from "../../../../assets/pages/NewHome/FeedbackSection/bottom-triangle.svg";
import { CLIENTS } from "./constants";

const TOTAL_TIME = 5000;

function FeedbackSection() {
  const [clientNumber, setClientNumber] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const timer = useRef<number>();

  const startTimer = () => {
    if (isPaused) return;

    timer.current = setTimeout(() => {
      setClientNumber((prevNumber) =>
        prevNumber + 1 === CLIENTS.length ? 0 : prevNumber + 1
      );
    }, TOTAL_TIME) as unknown as number;
  };

  useEffect(() => {
    startTimer();

    return () => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
    };
  }, [clientNumber, isPaused]);

  function handleCheckFeedback(number: number) {
    if (timer.current) {
      clearTimeout(timer.current);
    }

    setClientNumber(number);
    setIsPaused(true);
  }

  const currentClient = CLIENTS[clientNumber];

  return (
    <Wrapper>
      <ImageContainer>
        <TopTriangle src={topTriangleSvg} alt="" />
        <MainImage src={karenImg} alt="Karen, integrante do time da 7Cantos" loading="eager" />
        <BottomTriangle src={bottomTriangleSvg} alt="" />
      </ImageContainer>
      <TitleFeedbacksWrapper>
        <Title>Depoimentos Reais</Title>
        <Description>
          Veja o que nossos administradores de propriedades, proprietários e
          inquilinos têm a dizer
        </Description>

        <Feedback>{currentClient.statement}</Feedback>
        <ClientName>
          {currentClient.name}, <em>{currentClient.type}</em>
        </ClientName>

        <ImagesWrapper>
          {CLIENTS.map((client, index) => {
            const isActive = index === clientNumber;
            const showRing = isActive && !isPaused;

            return (
              <ImageWrapper key={client.name}>
                <ClientImage
                  onClick={() => handleCheckFeedback(index)}
                  className={isActive ? "active" : undefined}
                  src={client.img_url}
                  alt={`${client.name}, ${client.type} da 7Cantos`}
                />
                <ProgressRingWrapper
                  className={showRing ? "active" : undefined}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 80 80"
                  aria-hidden
                >
                  <ProgressRing
                    cx="40"
                    cy="40"
                    r="36"
                    className={showRing ? "active" : undefined}
                    strokeLinecap="round"
                  />
                </ProgressRingWrapper>
              </ImageWrapper>
            );
          })}
        </ImagesWrapper>
      </TitleFeedbacksWrapper>
    </Wrapper>
  );
}

export default FeedbackSection;
